'use client'

import { useReportWebVitals } from 'next/web-vitals'
import { getAnalytics } from '@/lib/analytics/client'

export function WebVitals() {
  useReportWebVitals((metric) => {
    getAnalytics().capture('web_vitals', {
      name: metric.name,
      value: Math.round(metric.value),
      id: metric.id,
      rating: (metric as { rating?: string }).rating ?? null,
    })
  })
  return null
}
